export const homeConstants = {
    HOME_LOADING: 'HOME_LOADING',
    GETHOME_SUCCESS: 'GET_HOME_SUCCESS',
    GETHOME_FAILURE: 'GET_HOME_FAILURE',
    PUTHOME_SUCCESS: 'PUT_HOME_SUCCESS',
    PUTHOME_FAILURE: 'PUT_HOME_FAILURE',
}
